var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-lg-12 col-md-12 col-sm-12" },
      [
        _c(
          "c-table",
          {
            ref: "vendorUserTable",
            attrs: {
              title: "LBL0003052",
              tableId: "vendorUserTable",
              columns: _vm.grid.columns,
              data: _vm.grid.data,
              usePaging: false,
              hideBottom: true,
              columnSetting: false,
              selection: "multiple",
              rowKey: "vendorUserCd",
            },
            on: { "table-data-change": _vm.tableDataChange },
          },
          [
            _c(
              "template",
              { slot: "table-button" },
              [
                _c(
                  "q-btn-group",
                  { attrs: { outline: "" } },
                  [
                    _vm.editable && this.parentVendorCd
                      ? _c("c-btn", {
                          attrs: { label: "LBLADD", icon: "add" },
                          on: { btnClicked: _vm.addrow },
                        })
                      : _vm._e(),
                    _vm.editable && this.parentVendorCd
                      ? _c("c-btn", {
                          attrs: { label: "LBLREMOVE", icon: "remove" },
                          on: { btnClicked: _vm.removerow },
                        })
                      : _vm._e(),
                    _vm.editable && this.parentVendorCd
                      ? _c("c-btn", {
                          attrs: { label: "LBLSAVE", icon: "save" },
                          on: { btnClicked: _vm.saveVendorUser },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          2
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }